import { Component, OnInit } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { Router } from '@angular/router';
import { Label, Sublabel } from 'app/shared/models/Label-Persona/label-persona';
import { Menu } from 'app/shared/models/Menus/menus';
import { DataService } from 'app/shared/services/data/data.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-parameter-flux-actus',
  templateUrl: './parameter-flux-actus.component.html',
  styleUrls: ['./parameter-flux-actus.component.scss']
})
export class ParameterFluxActusComponent implements OnInit {

  // @Input() myMenuFluxActu: Menu[];
  myMenuFluxActu: Menu[];

  allComplete = false;

  label: Label;
  color: ThemePalette = 'primary';
  newMenuActuToSend: Menu[];

  constructor(
    private dataService: DataService,
    private userService: UserService,
    private uiService: UiService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // this.newMenuActuToSend = JSON.parse(JSON.stringify(this.myMenuFluxActu));
    this.getMenu();
    // this.getLabel(this.myMenuFluxActu);
  }

  cancel() {
    this.dataService.showBtnParamFluxActu.next(false);
  }

  updateAllComplete() {
    this.allComplete = this.label.sublabels != null && this.label.sublabels.every(t => t.completed);
  }

  someComplete(): boolean {
    if (this.label.sublabels == null) {
      return false;
    }
    return this.label.sublabels.filter(t => t.completed).length > 0 && !this.allComplete;
  }


  setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.label.sublabels == null) {
      return;
    }
    this.label.sublabels.forEach(t => t.completed = completed);
  }

  allVisibleOrNot(): void {
    let nbrVisible = 0;

    this.newMenuActuToSend.forEach(item => {
      if (item.regroupementFlag === true) {
        nbrVisible++;
      }
    });

    if (nbrVisible < this.newMenuActuToSend.length) {
      this.newMenuActuToSend.forEach(item => {
        if (item.regroupementFlag === false) {
          item.regroupementFlag = true;
        }
      });
    } else {
      this.newMenuActuToSend.forEach(item => {
        item.regroupementFlag = false;
      });
    }
  }

  oneElementVisibleOrNot(elSelect: Sublabel): void {
    this.newMenuActuToSend.forEach(item => {
      if (elSelect.name === item.title_Home) {
        if (item.regroupementFlag === true) {
          item.regroupementFlag = false;
        } else {
          item.regroupementFlag = true;
        }
      }
    });
  }

  submitChange() {
    this.userService.updateVisibilityMyMenuActu(this.newMenuActuToSend).subscribe(() => {
      this.uiService.openSnackBar('Les modifications ont été effectuées', '');
      this.dataService.showBtnParamFluxActu.next(false);
      this.getMenu();
    }, error => {
      this.uiService.openSnackBar(`Modification impossible : ${error}`, '');
    });
  }

  private getMenu(): void {
    this.userService.getMenuUser().subscribe(res => {
      const array: Menu[] = [];
      res.forEach(item => {
        if (item.menuType === 'Flux Actu') {
          array.push(item);
        }
        if (item.menuType === 'Default' && item.lien === 'actus-ligue') {
          array.push(item);
        }
      });
      this.myMenuFluxActu = array;


      this.newMenuActuToSend = JSON.parse(JSON.stringify(this.myMenuFluxActu));
      if (this.newMenuActuToSend.length) {
        this.getLabel(this.myMenuFluxActu);

      }
      this.dataService.menu.next(res);
    });
  }



  private convertToSubLabels(myMenuFluxActu: Menu[]): Sublabel[] {
    const subLabel: Sublabel[] = [];

    myMenuFluxActu.forEach(item => {
      const sbl: Sublabel = {
        name: item.title_Home,
        completed: item.regroupementFlag
      };

      subLabel.push(sbl);
    });

    return subLabel;
  }

  private getLabel(myMenuFluxActu: Menu[]) {
    const fluxConvert: Sublabel[] = this.convertToSubLabels(myMenuFluxActu);
    this.label = {
      name: 'Tous mes flux d\'actu',
      completed: false,
      color: 'primary',
      sublabels: fluxConvert
    };
    this.updateAllComplete();
  }

}
